/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DelegateDto } from '../../models/delegate-dto';

export interface AutomatedProcessGetAllDelegates$Params {
}

export function automatedProcessGetAllDelegates(http: HttpClient, rootUrl: string, params?: AutomatedProcessGetAllDelegates$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<DelegateDto>>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetAllDelegates.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DelegateDto>>;
    })
  );
}

automatedProcessGetAllDelegates.PATH = '/automated-process/delegate';